import React, { useState, useEffect } from 'react';
import { BarChart3, TrendingUp, Eye, Users, CheckCircle, Clock } from 'lucide-react';
import api from '../api';

export default function AnalyticsDashboard() {
  const [overviewStats, setOverviewStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOverview();
  }, []);

  const fetchOverview = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get('/api/analytics/overview', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setOverviewStats(response.data);
    } catch (err) {
      console.error('Error fetching analytics:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!overviewStats) return null;

  const stats = [
    {
      name: 'Total Jobs',
      value: overviewStats.total_jobs || 0,
      icon: BarChart3,
      color: 'blue',
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-600'
    },
    {
      name: 'Active Jobs',
      value: overviewStats.active_jobs || 0,
      icon: TrendingUp,
      color: 'green',
      bgColor: 'bg-green-100',
      textColor: 'text-green-600'
    },
    {
      name: 'Total Views',
      value: overviewStats.total_views || 0,
      icon: Eye,
      color: 'purple',
      bgColor: 'bg-purple-100',
      textColor: 'text-purple-600'
    },
    {
      name: 'Total Applications',
      value: overviewStats.total_applications || 0,
      icon: Users,
      color: 'indigo',
      bgColor: 'bg-indigo-100',
      textColor: 'text-indigo-600'
    },
    {
      name: 'Pending',
      value: overviewStats.pending_applications || 0,
      icon: Clock,
      color: 'yellow',
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-600'
    },
    {
      name: 'Accepted',
      value: overviewStats.accepted_applications || 0,
      icon: CheckCircle,
      color: 'green',
      bgColor: 'bg-green-100',
      textColor: 'text-green-600'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
        <BarChart3 className="text-blue-600" />
        Analytics Overview
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {stats.map((stat) => {
          const Icon = stat.icon;
          return (
            <div key={stat.name} className={`${stat.bgColor} rounded-lg p-4`}>
              <div className="flex items-center justify-between mb-2">
                <Icon className={stat.textColor} size={24} />
              </div>
              <p className="text-2xl font-bold text-gray-800">{stat.value}</p>
              <p className="text-sm text-gray-600">{stat.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
